import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { DocLinksMode } from '../../../models/docLinks/docLinks';
import { ClientContext } from '../../context/IContextService';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class FilterRecordsCommand extends CategoryCommand<any> {
  public isAvailable(context: ClientContext): boolean {
    return (
      context.has('ParentCategory') ||
      context.get('InParams')?.linksGraph?.mode !== DocLinksMode.SINGLE
    );
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.FILTER,
    };
  }

  public getIcon(): IconName {
    return 'filter';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.FilterRecords;
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.ALL;
  }
}

export default FilterRecordsCommand;
